// extracted by mini-css-extract-plugin
export default {"AddClientsTagsDialog":"AddClientsTagsDialog_AddClientsTagsDialog__AVLik"};